import { Link, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ChecklistIssues } from "Components/Merchant/OrbitL/ChecklistIssues";
import type { ChecklistItemDto } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.OrbitL.Checklist;

export type ChecklistRow = {
  label: string;
  item: ChecklistItemDto;
  validation: string;
  link: string | null;
  action?: ReactNode;
  areIssuesHidden?: boolean;
};

export const ChecklistInvalidItem = ({
  label,
  item,
  validation,
  link,
  action,
  areIssuesHidden,
}: ChecklistRow) => {
  const { t } = useResource();

  return (
    <ListItem sx={{ py: 0.5, alignItems: "flex-start" }}>
      <ListItemIcon sx={{ minWidth: 36, mt: 0.5 }}>
        <InfoOutlinedIcon sx={{ color: "warning.main" }} />
      </ListItemIcon>
      <ListItemText
        primary={label}
        secondary={
          <>
            {validation}
            {link && (
              <>
                {" "}
                <Link href={link}>{t(RESOURCES.GoToSettingsLink)}</Link>
              </>
            )}
            {!areIssuesHidden && <ChecklistIssues item={item} />}
            {action}
          </>
        }
        slotProps={{
          secondary: {
            color: "text.secondary",
            component: "div",
          },
        }}
      />
    </ListItem>
  );
};
